export interface ReaderProgressState {
  rowIndex: number;
  segmentIndex: number;
  updatedAt: number;
}

export interface ReaderSettings {
  waitPerBeadMs: number;
  languageCode: string;
  progressByPatternKey?: Record<string, ReaderProgressState>;
  lastPatternKey?: string;
  lastPatternId?: number;
  lastPatternName?: string;
  lastRowIndex?: number;
  lastSegmentIndex?: number;
}

export const DEFAULT_READER_SETTINGS: ReaderSettings = {
  waitPerBeadMs: 2000,
  languageCode: "en-US",
  progressByPatternKey: {},
  lastPatternKey: "",
  lastPatternId: 0,
  lastPatternName: "",
  lastRowIndex: 0,
  lastSegmentIndex: -1,
};
